// import $ from 'jquery';

export default {
    init() {
        // const titles = document.querySelectorAll('.animated-text');
        // if (titles && titles.length) {
        //     titles.forEach((title) => {
        //         const words = $(title).text().split(' ');
        //         $('.animated-text').empty();
        //         $.each(words, (i, v) => {
        //             $(title).append($('<span class="animate">').text(v));
        //         });
        //     });
        // }
    },
};
